import {CommonFileType} from '@toolify/server/src/services/FileTypeService/enum/CommonFileType'
import {FileThumbnailDisplayType} from '@toolify/client/src/modules/files/enum/FileThumbnailDisplayType'

export const CommonFileTypeToFileThumbnailDisplayTypeMap = new Map<CommonFileType, FileThumbnailDisplayType>([
  [CommonFileType.Other, FileThumbnailDisplayType.Unknown],
  [CommonFileType.Image, FileThumbnailDisplayType.Image],
  [CommonFileType.Audio, FileThumbnailDisplayType.Audio],
  [CommonFileType.Document, FileThumbnailDisplayType.Document],
  [CommonFileType.Video, FileThumbnailDisplayType.Video],
  [CommonFileType.Sheet, FileThumbnailDisplayType.Sheet],
  [CommonFileType.Markdown, FileThumbnailDisplayType.Markdown],
  [CommonFileType.Text, FileThumbnailDisplayType.Text],
  [CommonFileType.Archive, FileThumbnailDisplayType.Archive],
  [CommonFileType.Html, FileThumbnailDisplayType.Html],
])
